export const AB_TEST_LOCAL_STORAGE_KEY = 'visualizer-ab-test-360-camera-flight';

export type AbTestBucket = 'A' | 'B';

export interface AbTestInput {
	gmcBundleId?: string;
	gmcBundleVersion?: string;
	gmcBundleIdOptionB?: string;
	gmcBundleVersionOptionB?: string;
}

export interface ResolvedBundle {
	bundleId: string;
	bundleVersion: string;
	is360CameraFlight: boolean;
}

function readPersistedBucket(): AbTestBucket | null {
	try {
		const value = window.localStorage.getItem(AB_TEST_LOCAL_STORAGE_KEY);
		return value === 'A' || value === 'B' ? value : null;
	} catch {
		return null;
	}
}

function writePersistedBucket(bucket: AbTestBucket): void {
	try {
		window.localStorage.setItem(AB_TEST_LOCAL_STORAGE_KEY, bucket);
	} catch {
		return;
	}
}

export function resolveAbTestVariant(content: AbTestInput): ResolvedBundle {
	const bundleIdA = content.gmcBundleId ?? '';
	const bundleVersionA = content.gmcBundleVersion ?? '';
	const bundleIdB = content.gmcBundleIdOptionB ?? '';
	const bundleVersionB = content.gmcBundleVersionOptionB ?? '';

	const isOptionBConfigured = bundleIdB !== '' && bundleVersionB !== '';

	if (!isOptionBConfigured) {
		return {
			bundleId: bundleIdA,
			bundleVersion: bundleVersionA,
			is360CameraFlight: false
		};
	}

	let bucket = readPersistedBucket();
	if (bucket === null) {
		bucket = Math.random() < 0.5 ? 'A' : 'B';
		writePersistedBucket(bucket);
	}

	if (bucket === 'B') {
		return {
			bundleId: bundleIdB,
			bundleVersion: bundleVersionB,
			is360CameraFlight: true
		};
	}

	return {
		bundleId: bundleIdA,
		bundleVersion: bundleVersionA,
		is360CameraFlight: false
	};
}
